import moment from 'moment';
import { BadgeColors } from '../../../generic';
import TooltipBadge from '../../../generic/Badge/TooltipBadge';

/**
 * Displays the length of time from now of the issue found date.
 */
const FoundDateBadge = ({ createdAt }: { createdAt: string }) => {
  const foundDate = moment(createdAt);

  return (
    <>
      <div className="issue-item__text">
        Found
      </div>
      <TooltipBadge
        id={foundDate.toString()}
        tooltip={foundDate.format(moment.localeData()
          .longDateFormat('L'))}
        color={BadgeColors.White}
      >
        <div className="issue-item__text">
          {foundDate.fromNow()}
        </div>
      </TooltipBadge>
    </>
  );
};

export default FoundDateBadge;
